import AbstractInterieur from "./AbstractInterieur";
import Measurer from "../interaction/Measurer";
import HeightDragHandle from "./HeightDragHandle";

export default class FullHeightDragable extends AbstractInterieur {

    constructor(vsData) {
        super(vsData);
        this.dragHandles = [Measurer.BOTTOM, Measurer.TOP].map(border => {
            const handle = new HeightDragHandle(this, border);
            this.boxLocalO3.add(handle);
            return handle;
        });
    }

    setChangeable(changeable) {
        this.hoverable = changeable;
        this.draggable = changeable;
        this.tapable = changeable;
        this.dragBox.visible = changeable;
        this.dragHandles.forEach(h => h.visible = changeable);
    }

    onChangeInDragSelectHoverState() {
        this.dragHandles.forEach(handle => handle.onChangeInDragSelectHoverState());
        super.onChangeInDragSelectHoverState();
    }

}
